import axios from "axios";
import toast from "react-hot-toast";
import { useKotContext } from "../context/kotContext";
import { useEffect, useState } from "react";

const UpdateKotPrint = (arr1, tableNo, totalAmount, selectedServerName) => {
  const { kotNumber } = useKotContext(); // Removed serverName from context
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const customerId = localStorage.getItem("customerId");

  function getFormattedCurrentDate() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return [
      `${day}-${month}-${year}`,
      `${hours}:${minutes}${period.toLowerCase()}`,
    ];
  }

  useEffect(() => {
    const [formattedDate, formattedTime] = getFormattedCurrentDate();
    setDate(formattedDate);
    setTime(formattedTime);
  }, [customerId, tableNo]);

  const printKot = async () => {
    try {
      const response = await axios.patch(
        "https://api.rasoi.launchlysoftware.in/api/kotBillUpdate",
        {
          customerId: customerId,
          kotNo: kotNumber,
          data: {
            foodItem: arr1,
          },
          serverName: selectedServerName, // Use prop
        },
      );

      toast.success(response.data.message);

      const data = response.data.updatedFoodItems || [];

      const printData = `
    <style>
  @page {
    size: 72mm auto; /* 80mm paper = safe width ~72mm */
    margin: 0; /* no margins */
  }
  body {
    width: 72mm; /* match @page safe width */
    margin: 0;
    font-size: 12px;
    word-break: break-word; /* wrap long text */
  }
  h2 {
    font-size: 14px;
    margin-bottom: 8px;
  }
  p {
    margin: 3px 0;
    font-size: 12px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  td {
    padding: 4px;
    border: 1px solid #000;
  }
  td.name {
    width: 75%; /* allow space for quantity */
  }
  td.quantity {
    width: 25%;
    text-align: center;
  }
</style>
        <body>
          <h2>KOT Details:</h2>
          <p>Table No.: ${tableNo}</p>
          <p>KOT No.: ${kotNumber}</p>
          <p>Server: ${selectedServerName}</p>
          <p>Date: ${date}</p>
          <p>Time: ${time}</p>
          <p>Food Items:</p>
          <table>
            <thead>
              <tr>
                <td class="name">Name</td>
                <td class="quantity">Quantity</td>
              </tr>
            </thead>
            <tbody>
              ${
                Array.isArray(data)
                  ? data
                      .map(
                        (item) => `
                <tr>
                  <td class="name">${item.name}${
                          item.note ? ` - (${item.note})` : ""
                        }</td>
                  <td class="quantity">${
                    item.newQuantity - item.oldQuantity
                  }</td>
                </tr>
              `,
                      )
                      .join("")
                  : ""
              }
            </tbody>
          </table>
        </body>
      `;

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.top = "-9999px";
      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printData);
      iframeDoc.close();

      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    } catch (error) {
      console.error("Error saving bill:", error);
      toast.error("Error in Kot");
    }
  };

  return printKot;
};

export default UpdateKotPrint;
